import { type TFunction } from 'i18next';
import { PasswordStrengthNameEnum } from '../../enums';
import { IPasswordStrengthOption, TPasswordStrengthName } from './interfaces';

const PASSWORD_STRENGTH = {
  [PasswordStrengthNameEnum.VeryWeak]: { minStrength: 0, maxStrength: 20 },
  [PasswordStrengthNameEnum.Weak]: { minStrength: 21, maxStrength: 40 },
  [PasswordStrengthNameEnum.Medium]: { minStrength: 41, maxStrength: 60 },
  [PasswordStrengthNameEnum.Strong]: { minStrength: 61, maxStrength: 80 },
  [PasswordStrengthNameEnum.VeryStrong]: { minStrength: 81, maxStrength: 100 },
};

export const getPasswordStrengthOptions = (t: TFunction): IPasswordStrengthOption[] => [
  { label: t('passwordStrength.veryWeak'), value: PasswordStrengthNameEnum.VeryWeak },
  { label: t('passwordStrength.weak'), value: PasswordStrengthNameEnum.Weak },
  { label: t('passwordStrength.medium'), value: PasswordStrengthNameEnum.Medium },
  { label: t('passwordStrength.strong'), value: PasswordStrengthNameEnum.Strong },
  { label: t('passwordStrength.veryStrong'), value: PasswordStrengthNameEnum.VeryStrong },
];

export const getPasswordStrengthValues = (
  passwordStrengthName: TPasswordStrengthName,
) => PASSWORD_STRENGTH[passwordStrengthName as PasswordStrengthNameEnum] ?? {
  minStrength: undefined, maxStrength: undefined,
};

export * from './interfaces';
